import { render, staticRenderFns } from "./EditCustomerServiceDetails.vue?vue&type=template&id=864e029c&scoped=true&"
import script from "./EditCustomerServiceDetails.vue?vue&type=script&lang=js&"
export * from "./EditCustomerServiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerServiceDetails.vue?vue&type=style&index=0&id=864e029c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864e029c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VSystemBar})
